import { Flex, Heading, Text } from '@chakra-ui/react';

import { MarketplaceVehicle, formatVehicleSummary } from '../../../../../../utils/cars';
import MarketplaceCard from '../../MarketplaceCard';

type PostAcceptanceInactiveProps = {
  vehicle: MarketplaceVehicle;
};

const PostAcceptanceInactive = ({ vehicle }: PostAcceptanceInactiveProps) => (
  <MarketplaceCard>
    <Flex direction="column" gap="8px">
      <Heading as="h2" fontFamily="heading" fontSize="22px" fontWeight="700" color="leaseEndBlue">
        This sale is no longer active.
      </Heading>
      <Text fontSize="14px" color="gray.600">
        Reach out with any questions.
      </Text>
      <Text fontSize="13px" color="grayMedium" mt="8px">
        {formatVehicleSummary(vehicle)}
      </Text>
    </Flex>
  </MarketplaceCard>
);

export default PostAcceptanceInactive;
